import { render } from "./LbrxIconSelector.vue?vue&type=template&id=fabffce6"
import script from "./LbrxIconSelector.vue?vue&type=script&lang=js"
export * from "./LbrxIconSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__